/**
 * Correspondance entre une route et un chemin de menu, comparee PAR SEGMENT :
 * `/profils` ne correspond pas a `/profils-habilitations`, mais correspond bien
 * a `/profils/42`.
 */
export const correspond = (pathname, path) =>
  !!path && (pathname === path || pathname.startsWith(path + '/'));

/**
 * Chemin de menu le plus specifique correspondant a la route courante, ou null.
 *
 * Pourquoi le plus specifique et pas « tous ceux qui correspondent » : des
 * entrees de menu s'imbriquent. « Attestations digitales » porte
 * `/attestations-digitales` et « Commandes digitales »
 * `/attestations-digitales/commandes`. Sur la seconde route, les deux
 * correspondent - la premiere par prefixe - et les deux entrees s'allumaient.
 *
 * On ne peut pas pour autant abandonner la correspondance par prefixe : c'est
 * elle qui garde « Dossiers sinistres » (`/sinistres`) allume sur la fiche
 * `/sinistres/abc-123`, qui n'est pas une entree de menu. Retenir le chemin le
 * plus long concilie les deux : la fiche n'a pas de chemin plus specifique
 * qu'elle, l'imbrication oui.
 *
 * A chemins de meme longueur, le premier rencontre gagne - deux entrees ne
 * peuvent pas partager un chemin, mais mieux vaut en allumer une seule que deux
 * si la base devenait incoherente.
 */
export const cheminActifMenu = (menu, pathname) =>
  (menu ?? [])
    .flatMap((item) => [item.path, ...(item.children ?? []).map((enfant) => enfant.path)])
    .filter((path) => correspond(pathname, path))
    .reduce((meilleur, path) => (path.length > (meilleur?.length ?? 0) ? path : meilleur), null);
